// Import model
import { DataviewObjectTypeResponse } from '../models/DataviewObjectTypeResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterObjectTypeRequest } from '../models/FilterObjectTypeRequest';
import { ObjectType } from '../models/ObjectType';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterObjectTypeRequestSerializer } from './FilterObjectTypeRequestSerializer';
import { ObjectTypeSerializer } from './ObjectTypeSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewObjectTypeResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewObjectTypeResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewObjectTypeResponse instance
   */
  static deserialize(json: string): DataviewObjectTypeResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewObjectTypeResponse instance
   */
  static fromObject(obj: any): DataviewObjectTypeResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewObjectTypeResponse');
    }


    const instance: DataviewObjectTypeResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        ObjectTypeSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterObjectTypeRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewObjectTypeResponse instances
   */
  static deserializeArray(json: string): DataviewObjectTypeResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewObjectTypeResponse instance to a JSON string
   */
  static serialize(instance: DataviewObjectTypeResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewObjectTypeResponse instance to a plain object
   */
  static toObject(instance: DataviewObjectTypeResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        ObjectTypeSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterObjectTypeRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewObjectTypeResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewObjectTypeResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
